import ProductsService from "@/api/services/products";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  index: [],
  currentPage: 1,
  totalPages: 0,
  totalCount: 0,
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    getIndex(state) {
      return state.index;
    },
    getEnabledFieldStyle: () => (product) => {
      return product.enabled ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800";
    },
    toBeApproved: () => (product) => {
      return product.approvalStatus === "to_be_approved";
    },
    approvedAndMatched: () => (product) => {
      return product.approvalStatus === "approved" && product.contractStatus === "matched";
    },
    getApprovalStatusStyle: () => (product) => {
      switch (product.approvalStatus) {
        case "to_be_approved":
          return "bg-blue-100 text-blue-800";
        case "approved":
          return "bg-green-100 text-green-800";
        case "refused":
          return "bg-red-100 text-red-800";
        default:
          return "bg-gray-100 text-gray-800";
      }
    },
    getContractStatusStyle: () => (product) => {
      switch (product.contractStatus) {
        case "pending":
          return "bg-blue-100 text-blue-800";
        case "matched":
          return "bg-green-100 text-green-800";
        case "non_warrantable":
          return "bg-red-100 text-red-800";
        default:
          return "bg-gray-100 text-gray-800";
      }
    },
    getApprovalStatuses: () => () => {
      return ["to_be_approved", "approved", "refused"];
    },
    getContractStatuses: () => () => {
      return ["pending", "matched", "non_warrantable"];
    },
  },
  mutations: {
    setIndex(state, data) {
      state.index = data.records;
      state.currentPage = data.page.currentPage || 1;
      state.totalPages = data.page.totalPages || 0;
      state.totalCount = data.page.totalCount || 0;
    },
  },
  actions: {
    async fetchIndex(
      { commit },
      {
        storeId,
        productType,
        approvalStatus,
        contractStatus,
        enabled,
        category,
        keywords,
        online,
        page = 1,
        perPage = 25,
        includes = [],
      },
    ) {
      const response = await ProductsService.fetchIndex({
        storeId: [storeId],
        productType,
        approvalStatus,
        contractStatus,
        enabled,
        category,
        keywords,
        online,
        page,
        perPage,
        includes,
      });

      if (!response?.success) return response;

      const data = toCamelCase(response.data);

      commit("setIndex", data);
      return data;
    },

    async fetch(_, { id, includes = [] }) {
      return await ProductsService.fetch(id, { includes });
    },

    async enableProducts(_, { productIds }) {
      return await ProductsService.enable(productIds);
    },

    async disableProducts(_, { productIds }) {
      return await ProductsService.disable(productIds);
    },
  },
};
